import VUserIcon from './VUserIcon'
import TheModals from './Modals/TheModals'
import VStatisticalCard from './Statistical/VStatisticalCard'
import VUserPreview from './VUserPreview'
const VUserManagerTable = () => import('./UserManager/VUserManagerTable')
const VTable = () => import('./VTable')
const VSeeAllLink = () => import('./VSeeAllLink')
const VNotificationList = () => import('./NotificationList')
const TheAllCommentsTable = () => import('./AllComments/TheAllCommentsTable')
const VPagination = () => import('./VPagination')

export {
  VUserIcon,
  VUserPreview,
  VStatisticalCard,
  VUserManagerTable,
  VTable,
  VSeeAllLink,
  VNotificationList,
  TheAllCommentsTable,
  TheModals,
  VPagination
}
